export const PLAYER_VERSION = '2.2.0-jsx112.rc4';
export const PLAYER_BASE = `/static/player/${PLAYER_VERSION}`;
export const PLAYER_SCRIPT = 'pnp.player.js';
export const PLAYER_STYLE = 'pnp.player.css';
